/** @prettier */

/**
 * ゲートウェイの削除ダイアログ
 */

import React, {useState} from 'react';
import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
//API import
import {
  deleteCompositionsGateway,
  getCompositionsGateway,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';

import {gwInfoSort} from '../../functions/sort';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
import {checkGwInfoBillingStatus} from '../../functions/checkBillingStatus';

const GWDeleteDialog = (props: {
  gwID: string;
  gwName: string;
  gwBillingStatus: apiIF.resParameters.gatewayInformations['billing-status'];
  setGWInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsGateway | null>
  >;
  isOpenDialog: boolean;
  setIsOpenDialog: (arg0: boolean) => void;
}) => {
  //パスパラメータ取得
  const {siteID} = useParams();

  const [checked, setChecked] = useState(false); //チェックボックス
  const [disable, setDisable] = useState(true); //OKボタン非表示フラグ
  const [errorOpen, setErrorOpen] = useState(false); //APIエラー時エラーメッセージ表示
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  const trans = useTranslation().t; //翻訳関数

  /**
   * OKボタン押下時処理
   */
  const gwDelete = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) {
      return;
    }

    setAPIWait(true);
    setDisable(true);

    //ゲートウェイの削除
    deleteCompositionsGateway(siteID, props.gwID)
      .then(() => {
        //ゲートウェイの情報を取得
        return getCompositionsGateway(siteID, {'max-result': 100});
      })
      .then(response => {
        //表示内容をUnicode順に並び替え
        response = gwInfoSort(response);
        props.setGWInfo(response);
        handleClose();
      })
      .catch(() => {
        setErrorOpen(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
    setChecked(false);
    setDisable(true);
  };

  /**
   * チェックボックスの値変更時の処理
   * @param event
   * @param check
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    setDisable(!event.target.checked);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('GWDeleteDialog.title')}
        </DialogTitle>
        <DialogContent>
          {/* 現在のゲートウェイ名称を表示 */}
          <DialogContentText>
            {trans('GWDeleteDialog.msg')} {props.gwName}
          </DialogContentText>
          <DialogContentText>
            {checkGwInfoBillingStatus(props.gwBillingStatus) && (
              <span className="gWDeleteDialog__paidErrorMsg">
                {trans('GWDeleteDialog.paidErrorMsg1')}
                <br />
                {trans('GWDeleteDialog.paidErrorMsg2')}
              </span>
            )}
          </DialogContentText>
          {/* チェックボックス */}
          {checkGwInfoBillingStatus(props.gwBillingStatus) === false && (
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={e => handleChange(e)}
                    id={`mv-Check1DeleteGw${props.gwName}`}
                  />
                }
                checked={checked}
                label={trans('GWDeleteDialog.checkboxDescription')}
              />
            </FormGroup>
          )}
        </DialogContent>
        {/* OK/CANCELボタン */}
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('GWDeleteDialog.buttonTxt.cancel')}
            id={`mv-btnCancelDeleteGw${props.gwName}`}
          />
          <PrimaryButton
            onClick={gwDelete}
            buttonText={trans('GWDeleteDialog.buttonTxt.ok')}
            id={`mv-btnOkDeleteGw${props.gwName}`}
            disabled={disable}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={errorOpen}
        setOpen={setErrorOpen}
        id={`${props.gwName}DeleteErrDlgBtn`}
      />
    </>
  );
};
export default GWDeleteDialog;
